import messages from "@smartmixin/i18n/dist/translations/sk.json";

export default messages;
